<div class="header">
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Dash Enterprise</h1>
      </div>
    </div>
  </div>
</div>

<div class="content menu" [class.noWebp]="noWebp">
  <div class="contentInner">
    <p class="intro">Dash Enterprise allows you to centrally manage your Dash display devices.  Rather than configuring
      Dash individually on each device, you can configure Dash using an MDM solution or our web dashboard,
      and have your chosen settings automatically deployed to your displays.</p>
    <p class="tip icon"><span>Please note that a subscription to our <a routerLink="/pricing">Enterprise Plan</a> is required to
      use the features described here.</span></p>

    <p>There are two ways to manage your Dash devices with Dash Enterprise: Through our web dashboard, or by using an MDM
      provider.  You can choose either of these methods, or use them both together.</p>

    <div class="optionsContainer">
      <div class="enterpriseOption">
        <h3>Web dashboard</h3>
        <div class="illustration dashboard"></div>
        <p>The web dashboard is included with all Dash Enterprise subscriptions, and allows you to manage all of your Dash
          devices from the web.  Choose which options you want to manage centrally, and apply them to your devices.  </p>
        <p>This is the best option for Organizations that aren't already using an MDM solution</p>
        <a class="button" routerLink="dashboard">Web dashboard guide</a>
      </div>

      <div class="enterpriseOption">
        <h3>MDM Service</h3>
        <div class="illustration mdm"></div>
        <p>Dash is compatible with all major MDM services
          (such as <a href="https://learn.microsoft.com/en-us/mem/intune/fundamentals/what-is-intune" target="_blank">
            Microsoft InTune</a> and <a href="https://www.jamf.com/" target="_blank">Jamf</a>).  MDM services let you
          control more than just Dash's settings (for example you can set Dash to run when the device starts up), but
          you'll need a subscription to an MDM solution to get started.  </p>

        <p>If your organization is already using an MDM
          solution, this could be the best option for you as you can control Dash's settings from the same place you
          manage your other enterprise applications.</p>

        <a class="button" routerLink="mdm">MDM setup guide</a>
      </div>
    </div>
  </div>
</div>
